export default "__VITE_ASSET__DHvaVQ65__"